import { useContext, useEffect, useState } from "react";
import "./ContextMenu.css";
import { MenuItem, Popover } from "@mui/material";
import { ContextMenuContext } from "../../contexts/ContextMenuContext";
import { getContextMenuOptions } from "../../services/contextMenuService";
import { useSnackBar } from "../../hooks/useSnackBar";

export const ContextMenu = () => {
  const [options, setOptions] = useState([]);
  const { closeMenu, elementContext, anchorPosition } =
    useContext(ContextMenuContext);
  const { warningMsg } = useSnackBar();

  useEffect(() => {
    if (elementContext?.type)
      getContextMenuOptions(elementContext)
        .then((response) => {
          if (response.data.responseCode === 200) {
            let allowedOptions = (
              response.data.load?.map?.(
                (actionKey) => elementContext.availableOptions?.[actionKey]
              ) ?? []
            ).filter((x) => !!x);
            allowedOptions.length > 0
              ? setOptions(allowedOptions)
              : closeMenu();
          } else {
            closeMenu();
          }
        })
        .catch((error) => {
          console.error(error);
          closeMenu();
        });
  }, [elementContext]);

  const handleClose = () => {
    closeMenu();
  };

  const optionClick = (option) => {
    try {
      option.callback?.(elementContext.data);
    } catch (error) {
      console.error(error);
      warningMsg(`Action "${option.label}" failed: ${error.message}`);
    }
    closeMenu();
  };

  const open = Boolean(anchorPosition && options?.length > 0);
  const id = open ? "simple-popover" : undefined;

  return (
    <div
      onContextMenu={(e) => {
        e.preventDefault();
        closeMenu();
        e.stopPropagation();
      }}
      className="context-menu-component"
    >
      <Popover
        id={id}
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition}
        onClose={handleClose}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            style: {
              borderRadius: "12px",
              boxShadow: "var(--pop-over-shadow)",
            },
          },
        }}
      >
        <div className="menu-options">
          {options.map((option) => (
            <div
              key={option.label}
              className="option"
              onClick={() => optionClick(option)}
            >
              {option.icon && <i className={option.icon}></i>}
              <span>{option.label}</span>
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
};
